/**
 * isStandalonePWA — true quando o app roda como PWA INSTALADO.
 * Cobre Android/Chrome (display-mode: standalone) e iOS Safari (navigator.standalone).
 */
export function isStandalonePWA(): boolean {
  if (typeof window === 'undefined') return false
  try {
    if (typeof window.matchMedia === 'function'
        && window.matchMedia('(display-mode: standalone)').matches) {
      return true
    }
  } catch {
    // matchMedia indisponível
  }
  return (navigator as unknown as { standalone?: boolean })?.standalone === true
}
